import { Component, ElementRef, ContentChild, NgModule } from '@angular/core';
import { merge, fromEvent } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/textarea-autoheight/textarea-autoheight.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["textarea"];
const _c1 = ["*"];
class TextareaAutoheightComponent {
    /**
     * @param {?} elRef
     */
    constructor(elRef) {
        this.elRef = elRef;
    }
    /**
     * @param {?} textAreaRef
     * @return {?}
     */
    set textarea(textAreaRef) {
        this.clearSubscription();
        if (textAreaRef && textAreaRef.nativeElement) {
            /** @type {?} */
            const textArea = textAreaRef.nativeElement;
            textArea.style.boxSizing = 'border-box';
            textArea.style.overflow = 'hidden';
            this.subscription = merge(fromEvent(textArea, 'keyup'), fromEvent(textArea, 'change'))
                .subscribe((/**
             * @return {?}
             */
            () => {
                this.elRef.nativeElement.style.height = this.elRef.nativeElement.offsetHeight + 'px';
                textArea.style.height = '';
                textArea.style.height = textArea.scrollHeight + 5 + 'px';
                this.elRef.nativeElement.style.height = '';
            }));
        }
    }
    ;
    /**
     * @private
     * @return {?}
     */
    clearSubscription() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            delete this.subscription;
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.clearSubscription();
    }
}
TextareaAutoheightComponent.ɵfac = function TextareaAutoheightComponent_Factory(t) { return new (t || TextareaAutoheightComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TextareaAutoheightComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextareaAutoheightComponent, selectors: [["egov-textarea-autoheight"]], contentQueries: function TextareaAutoheightComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textarea = _t.first);
    } }, ngContentSelectors: _c1, decls: 1, vars: 0, template: function TextareaAutoheightComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:block}"] });
/** @nocollapse */
TextareaAutoheightComponent.ctorParameters = () => [
    { type: ElementRef }
];
TextareaAutoheightComponent.propDecorators = {
    textarea: [{ type: ContentChild, args: ['textarea', { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaAutoheightComponent, [{
        type: Component,
        args: [{ selector: 'egov-textarea-autoheight', template: "<ng-content></ng-content>", styles: [":host{display:block}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { textarea: [{
            type: ContentChild,
            args: ['textarea', { static: false }]
        }] }); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    TextareaAutoheightComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    TextareaAutoheightComponent.prototype.elRef;
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/textarea-autoheight.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TextareaAutoheightModule {
}
TextareaAutoheightModule.ɵfac = function TextareaAutoheightModule_Factory(t) { return new (t || TextareaAutoheightModule)(); };
TextareaAutoheightModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TextareaAutoheightModule });
TextareaAutoheightModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextareaAutoheightModule, [{
        type: NgModule,
        args: [{
                declarations: [TextareaAutoheightComponent],
                exports: [TextareaAutoheightComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TextareaAutoheightModule, { declarations: [TextareaAutoheightComponent], exports: [TextareaAutoheightComponent] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: egovsolutions-angular-textarea-autoheight.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { TextareaAutoheightModule, TextareaAutoheightComponent as ɵa };

